<template>
    <header v-if="showHeader"
            class="relative bg-black border-b border-gray-600
                   md:flex
                     ">
      <div class="flex items-center justify-between ">
        <router-link
          :to="{ name: 'home' }"
          class="px-4">
          <Logo class="h-4" />
        </router-link>
        <Button
          type="text"
          @onClick="isOpen = !isOpen"
          class="text-white md:hidden">
          {{ isOpen ? 'Close' :  'Menu' }}
        </Button>
      </div>
      <Navigation :class="isOpen ? 'flex' : 'hidden'" class="mt-4 md:mt-0 md:flex" />
    </header>
</template>

<script>
import Button from '@/components/Button.vue';
import Logo from '@/assets/orbital_logo.svg?inline';
import Navigation from '@/components/Navigation.vue';

export default {
  name: 'Header',
  components: {
    Button,
    Logo,
    Navigation,
  },
  data() {
    return {
      isOpen: false,
      headerBlacklist: ['login', 'register', 'signup'],
    };
  },
  computed: {
    showHeader() {
      return this.headerBlacklist.indexOf(this.$route.name) === -1;
    },
  },
};
</script>

<style scoped>

</style>
